var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchool2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M450 512L450 540",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 450.5,
    cy: 507.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M461.829 504.888L451.354 501.027C451.278 500.991 451.202 500.991 451.126 501.027L440.651 504.888C440.651 504.888 440.651 504.888 440.632 504.888C440.613 504.888 440.613 504.906 440.594 504.906C440.594 504.906 440.575 504.906 440.575 504.923C440.556 504.923 440.556 504.941 440.537 504.941C440.537 504.941 440.537 504.941 440.518 504.959C440.499 504.976 440.499 504.976 440.48 504.994C440.48 505.012 440.461 505.012 440.461 505.03V505.047C440.461 505.065 440.461 505.065 440.442 505.083V505.1C440.442 505.118 440.442 505.136 440.442 505.154V509.741C439.626 509.883 439 510.556 439 511.353C439 512.256 439.797 513 440.765 513C441.733 513 442.53 512.256 442.53 511.353C442.53 510.538 441.903 509.883 441.087 509.741V505.579L443.118 506.323V509.387C443.118 510.272 443.991 511.087 445.604 511.689C447.122 512.238 449.115 512.557 451.24 512.557C453.366 512.557 455.377 512.256 456.876 511.689C458.47 511.105 459.362 510.29 459.362 509.387V506.323L461.81 505.419C461.924 505.384 462 505.277 462 505.154C462 505.03 461.943 504.941 461.829 504.888ZM441.922 511.353C441.922 511.937 441.41 512.415 440.784 512.415C440.158 512.415 439.645 511.937 439.645 511.353C439.645 510.768 440.158 510.29 440.784 510.29C441.41 510.29 441.922 510.768 441.922 511.353ZM458.755 509.404C458.755 510.662 455.738 511.99 451.24 511.99C446.743 511.99 443.725 510.644 443.725 509.404V506.553L451.126 509.28C451.164 509.298 451.202 509.298 451.24 509.298C451.278 509.298 451.316 509.298 451.354 509.28L458.755 506.553V509.404ZM458.945 505.88L451.24 508.714L443.535 505.862L441.6 505.154L451.24 501.593L460.88 505.154L458.945 505.88Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchool2);
export default __webpack_public_path__ + "static/media/school_2.aaffb870987e7d046b991902ffa671a5.svg";
export { ForwardRef as ReactComponent };